import { render } from "./InvestasiDataResiko.vue?vue&type=template&id=34e5b1fc"
import script from "./InvestasiDataResiko.vue?vue&type=script&lang=js"
export * from "./InvestasiDataResiko.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__